export const NODE_TYPE_QUERY = 'query';
export const NODE_TYPE_CLAUSE = 'clause';
export const NODE_TYPE_OPERAND = 'operand';
export const NODE_TYPE_ORDER_BY = 'order_by';
